module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "numericCriteria"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comparison),
      expression: "comparison"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.comparison = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "N/A"
    }
  }, [_vm._v("N/A")]), _vm._v(" "), _c('option', [_vm._v(">")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "<"
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "<="
    }
  }, [_vm._v("<=")]), _vm._v(" "), _c('option', [_vm._v(">=")]), _vm._v(" "), _c('option', [_vm._v("=")]), _vm._v(" "), _c('option', [_vm._v("!=")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.enteredNumber),
      expression: "enteredNumber"
    }],
    attrs: {
      "type": "number",
      "disabled": _vm.comparison == 'N/A'
    },
    domProps: {
      "value": (_vm.enteredNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.enteredNumber = $event.target.value
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cef889d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NumericCriteriaInput.vue
// module id = 129
// module chunks = 0